import { motion } from 'framer-motion';

export function SuccessMessage() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      className="bg-white rounded-3xl p-12 shadow-sm border border-gray-100 max-w-3xl mx-auto text-center"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", duration: 0.5 }}
        className="flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-[#ffce04] to-[#ff8a47] text-white mx-auto mb-6"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </motion.div>
      <h2 className="text-3xl font-bold text-gray-900 mb-4">resposta enviada com sucesso!</h2>
      <p className="text-xl text-gray-700">
        entraremos em contato em breve através do seu e-mail!
      </p>
    </motion.div>
  );
}
